import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useContext } from "react";
import { Context } from "../../Context/ContextApi";
const FeaturedPaintings = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
 
  const {featuredPaintings} = useContext(Context)
  //console.log(featuredPaintings?.data?.data)
  const featuredPaintingsData = featuredPaintings?.data?.data


  return (
    <>
      <div className="container-fluid mt-3 featured-paintings">
        <h1>Our Featured Paintings</h1>
        <div className="row">
          <Slider {...settings}>
            {featuredPaintingsData?.map((item) =>(
               <div className="col-md-6">
               <div class="painting">
                 <img src={`https://admin.tulikaarts.in/${item?.painting_image}`} alt={item.painting_name} />
                 <h3>{item.painting_name }</h3>
               </div>
             </div>
            ))}
                  
           
          </Slider>
        </div>
      </div>
    </>
  );
};

export default FeaturedPaintings;
